import { ConexionCompleta } from "@victorequena22/conneccion";

class NotaConexion extends ConexionCompleta {
    clase = 'Nota';
    persistencia = 1000;
}
export default function conNota() {
    return new NotaConexion();
}